/* eslint-disable import/no-cycle */
import React from 'react';
import PropTypes from 'prop-types';
import { Flex, Box } from 'rebass';

import { Radio } from '@oca/ui';

/**
 * Final-form wrapper rendering a single-select group of `Radio`s from
 * `options` ([{ value, label }]). The selected option's `value` is the field
 * value. Option values are coerced to strings for the underlying radio input.
 */
export function RadioGroupWrapper({ input, options, direction, disabled }) {
  return (
    <Flex
      flexDirection={direction === 'row' ? 'row' : 'column'}
      flexWrap="wrap"
    >
      {options.map(option => (
        <Box
          key={String(option.value)}
          mr={direction === 'row' ? 20 : 0}
          mb={direction === 'row' ? 0 : 10}
        >
          <Radio
            name={input.name}
            value={String(option.value)}
            label={option.label}
            checked={String(input.value) === String(option.value)}
            onChange={() => input.onChange(option.value)}
            disabled={disabled}
          />
        </Box>
      ))}
    </Flex>
  );
}

RadioGroupWrapper.propTypes = {
  input: PropTypes.shape({
    name: PropTypes.string,
    value: PropTypes.any,
    onChange: PropTypes.func,
  }).isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    }),
  ).isRequired,
  direction: PropTypes.oneOf(['row', 'column']),
  disabled: PropTypes.bool,
};

RadioGroupWrapper.defaultProps = {
  direction: 'column',
  disabled: false,
};
